import { Grid, InputAdornment, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Button, Input, InputAuto, InputDate } from "../../../controls";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../App";
import { Dialog } from "../../../layout";
import AddEditCstmr from "../../customer/AddEditCstmr";
import { action, controller, Server } from "../../../api/Server";
import SendReceiptToEmail from "./SendReceiptToEmail";
import { CheckCircleRounded } from "@mui/icons-material";
import QuoteSale from "./QuoteSale/QuoteSale";
import { CartContext } from "../Pos";

const CustomerSect = (props) => {
  const {
    values,
    setValues,
    errors,
    handleInpDate,
    store,
    setTotalPay,
    setTax,
    setTaxPct,
    access,
    needToPayAmt,
    setEmailInv,
    emailInv,
    handleClearCart,
    setNeedToPayAmt,
    handleSubmit,
  } = props;
  const { editSale, quote } = useContext(CartContext);
  const { selStore, settings } = useContext(AppContext);
  const { t } = useTranslation();
  const [selCstmr, setSelCstmr] = useState({});
  const [cstmrs, setCstmrs] = useState([]);
  const [cstmrAccBal, setCstmrAccBal] = useState(0);
  const [showCstmrForm, setShowCstmrForm] = useState(false);
  const [creditAmt, setCreditAmt] = useState(0);
  const [creditValidate, setCreditValidate] = useState(false);

  useEffect(() => {
    if (editSale && editSale.cstmrId) {
      setSelCstmr({ ...editSale.cstmr });
      setValues((j) => ({ ...j, cstmrId: editSale.cstmrId }));
    } else if (quote && quote.customerId) {
      setSelCstmr({ ...quote.customer });
      setValues((j) => ({ ...j, cstmrId: quote.customerId }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editSale, quote]);

  useEffect(() => {
    // Get Customers
    Server(controller.Customer + action.GetAllByOrg).get((res) => {
      setCstmrs([
        ...res.result.map((j) => ({
          label: j.fullName,
          subtitle: j.cstmrCode + " | " + j.phone,
          ...j,
        })),
      ]);
    });

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selStore]);

  useEffect(() => {
    if (selCstmr.id) {
      Server(controller.Customer + action.GetCstmrAccBal).getById(
        selCstmr.id,
        (res) => {
          var balance = res.result;
          setCstmrAccBal(res.result);
          balance >= needToPayAmt
            ? setCreditAmt(needToPayAmt)
            : setCreditAmt(balance);
        }
      );
    } else setCstmrAccBal(0);
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selCstmr]);

  /* Handle Customer & Tax Calculation */
  const handleCstmr = (e) => {
    var cstmrVal = cstmrs.find((j) => j.id === e.target.value);

    // Calculate Tax Item;
    var _taxItemTotal = values.sellItems
      .filter((j) => j.tax === 1)
      .map((j) => j.qty * j.price)
      .reduce((x, y) => x + y, 0)
      .toFixed(settings.decimal);
    // Find out tax Percentage;
    var _taxPct = parseFloat(
      cstmrVal && cstmrVal.specialTaxPayer ? cstmrVal.vatTax || 0 : store.tax
    );
    setTaxPct(_taxPct);
    // Calculate Tax Amount;
    var _tax = (_taxPct / 100) * _taxItemTotal || 0;

    if (cstmrVal) {
      setSelCstmr(cstmrVal);
      if (cstmrVal.taxExempt) {
        setValues((j) => ({
          ...j,
          tax: "",
          taxPct: "",
          wasSpecialTaxpayer: false,
        }));
        setTotalPay(values.subtotal);
        setTax(0);
        setTaxPct(0);
      } else if (!cstmrVal.taxExempt) {
        setTaxAction(_tax, _taxPct);
        setValues((j) => ({
          ...j,
          wasSpecialTaxpayer: cstmrVal.specialTaxPayer,
        }));
      }
    } else {
      setSelCstmr({});
      setTaxAction(_tax, _taxPct);
    }

    setValues((j) => ({
      ...j,
      cstmrId: e.target.value,
      sellType: !e.target.value ? 1 : j.sellType,
      taxExempt: cstmrVal ? cstmrVal.taxExempt : false,
    }));
  };

  const setTaxAction = (taxAmt = 0, taxPct = 0) => {
    setTotalPay(values.subtotal + taxAmt);
    setTax(taxAmt);
    setValues((j) => ({
      ...j,
      taxPct: taxPct,
      tax: taxAmt,
    }));
  };

  const handleAddCstmr = () => {
    setShowCstmrForm(!showCstmrForm);
  };

  const handleDue = () => {
    setValues((prev) => ({ ...prev, dueAmt: needToPayAmt, sellType: 2 }));
    setNeedToPayAmt(0);
  };
  useEffect(() => {
    if (values.sellType === 2 && needToPayAmt === 0) {
      handleSubmit();
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.sellType, needToPayAmt]);

  const handleCredit = (e) => {
    var inpVal = e.target.value;
    if (
      creditAmt.length > inpVal.length ||
      (parseFloat(inpVal) <= parseFloat(cstmrAccBal) &&
        parseFloat(inpVal) <= parseFloat(needToPayAmt))
    ) {
      setCreditAmt(inpVal);
      setCreditValidate(false);
      setValues((prev) => ({ ...prev, creditAmt: "" }));
    }
  };

  const handleCreditValidate = () => {
    if (parseFloat(creditAmt) > 0) {
      setValues((prev) => ({ ...prev, creditAmt: creditAmt }));
      setCreditValidate(true);
    }
  };

  return settings ? (
    <Paper
      className="p-5 bg-white"
      sx={{
        border: "1px solid var(--primarySM-color)",
        boxShadow: "var(--shadow-xs)",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="d-flex g-5">
            <div className="w-100pr">
              <InputAuto
                className="fs-20"
                variant="outlined"
                placeholder={t("selectCustomer")}
                value={selCstmr.id}
                options={cstmrs}
                onChange={handleCstmr}
                size="small"
                sx={{
                  "& .MuiInputBase-input": {
                    fontWeight: "500",
                    color: "var(--gray-color)",
                  },
                }}
              />
            </div>
            {!selCstmr.id && (
              <div className="d-flex">
                <Button
                  onClick={handleAddCstmr}
                  variant="text"
                  size="small"
                  className="h-100pr fs-12"
                  sx={{ lineHeight: "20px", width: "max-content" }}
                >
                  {t("addCustomer")}
                </Button>
              </div>
            )}
          </div>
        </Grid>
        {values.cstmrId && access.isHaveDueSaleAccess && (
          <>
            <Grid item xs={12} md={6}>
              <div className="d-grid g-10 gray-color">
                {cstmrAccBal > 0 && (
                  <div>
                    <Input
                      fullWidth
                      placeholder={t("useCredit")}
                      value={creditAmt}
                      onChange={handleCredit}
                      className="rmv-arrow br-8"
                      variant="outlined"
                      type="number"
                      size="small"
                      onInput={(e) =>
                        e.target.value > 0 ? e : (e.target.value = "")
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <span className="gray-color ">
                              {settings.curSymbol}
                            </span>
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            {creditValidate ? (
                              <CheckCircleRounded
                                color="success"
                                className="pr-5"
                              />
                            ) : (
                              <Button
                                onClick={handleCreditValidate}
                                variant="text"
                                sx={{
                                  minWidth: "80px",
                                  fontSize: "12px",
                                  padding: "7px",
                                }}
                              >
                                Validate
                              </Button>
                            )}
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          paddingRight: "2.5px",
                        },
                      }}
                    />
                  </div>
                )}
                {access.isHaveDueSaleAccess && (
                  <div className="ml-10">
                    {settings.curSymbol}&nbsp;
                    <span className="fs-20 fw-5">
                      {cstmrAccBal.toFixed(settings.decimal)}
                      &nbsp;
                    </span>
                    <span className="fs-12 tx-upp">{t("storeCredit")}</span>
                  </div>
                )}
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              {/* Due Sale */}
              <div className="d-grid gray-color g-5">
                <InputDate
                  placeholder={t("dueDate")}
                  name="dueDate"
                  value={values.dueDate}
                  error={errors.dueDate}
                  variant="outlined"
                  size="small"
                  minDate={new Date()}
                  views={["day", "month", "year"]}
                  onChange={(date) =>
                    handleInpDate("dueDate", new Date(date).toISOString())
                  }
                />
                <Button onClick={handleDue}>{t("creditSale")}</Button>
              </div>
            </Grid>
          </>
        )}

        {/* Email Invoice Button */}
        {settings.emailInvoice === 1 && values.cstmrId && (
          <Grid item xs={12} md={6}>
            <SendReceiptToEmail {...{ setEmailInv, emailInv }} />
          </Grid>
        )}

        {/* ------ Quote Sale ------ */}
        <QuoteSale {...{ values, emailInv, handleClearCart }} />
      </Grid>

      {showCstmrForm && (
        <Dialog show={showCstmrForm} onClose={false} maxWidth="lg">
          <AddEditCstmr
            {...{
              setOpen: setShowCstmrForm,
              openOnDialog: true,
              setCstmrs,
              setSelCstmr,
              setInvVal: setValues,
            }}
          />
        </Dialog>
      )}
    </Paper>
  ) : (
    "Loading..."
  );
};

export default CustomerSect;
